import { useNavigate } from "flemo";
import { SettingsIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";

export function Header() {
  const { push } = useNavigate();

  return (
    <header className="p-5 pt-2 shrink-0 flex items-start justify-between w-full mx-auto max-w-4xl">
      <div className="flex flex-col gap-1">
        <h1 className="text-3xl font-extrabold text-white">TEST</h1>
        <p className="text-sm text-white/70">암기한 단어를 테스트해보세요</p>
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label="설정"
        onClick={() => {
          void trackEvent("settings_opened", { source: "tests" });
          push("/settings");
        }}
      >
        <SettingsIcon className="size-5 text-white/70" />
      </Button>
    </header>
  );
}
